import * as DataDogLogs from '~/lib/datadog/datadog';

export const formatCurrency = (amount) => {
  // Attempt to get currency and locale from Shopify object, with fallbacks
  const shopifyCurrency =
    typeof Shopify !== 'undefined' && Shopify.currency ? Shopify.currency.active : 'USD';
  const shopifyLocale = typeof Shopify !== 'undefined' && Shopify.locale ? Shopify.locale : 'en-US';

  // Determine if the input amount is likely in cents (integer) or base units (float).
  // Shopify APIs often provide amounts in cents as integers.
  const isInputInteger = Number.isInteger(amount);

  // Amount for Shopify.formatMoney (expects cents)
  const amountForShopify = isInputInteger ? amount : Math.round(amount * 100);

  // Amount for Intl.NumberFormat and fallback (expects base unit value)
  const amountInBaseUnitForIntl = isInputInteger ? amount / 100 : amount;

  if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
    try {
      // Force a Shopify format that shows no decimals.
      // This ensures the "no decimals" requirement is met, overriding theme defaults if they show decimals.
      return Shopify.formatMoney(amountForShopify, '${{amount_no_decimals}}');
      // eslint-disable-next-line no-unused-vars
    } catch (e) {
      // Silently catch errors and proceed to Intl.NumberFormat, as per original logic.
      /* empty */
    }
  }

  try {
    return new Intl.NumberFormat(shopifyLocale, {
      currency: shopifyCurrency,
      maximumFractionDigits: 0, // Ensure no decimals
      minimumFractionDigits: 0, // Ensure no decimals
      style: 'currency',
    }).format(amountInBaseUnitForIntl);
  } catch (error) {
    DataDogLogs.error(
      '[Allbirds utils] - formatCurrency - Error formatting currency with Intl.NumberFormat:',
      { amount, shopifyCurrency, shopifyLocale },
      error,
    );
    // Fallback to a simple formatting if Intl.NumberFormat fails, ensuring no decimals.
    return `${shopifyCurrency} ${Math.round(amountInBaseUnitForIntl)}`;
  }
};

export const removeCurrencySymbol = (amount) => {
  return amount.replace(/(^|[^a-zA-Z])(\$|€|£|\xa3)/g, '');
};
